import React from "react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import YellowDivider from "../dividers/YellowDivider";
import "../../stylesheet/components/pageheading/PageHeading.scss";

type PageHeadingProps = {
  className?: string;
  yellowDividerSmall?: boolean;
  title: string;
  subtitle?: string;
  isPageHeading?: boolean;
  body: string;
  children?: JSX.Element[] | JSX.Element;
};

const PageHeadingWithImage: React.FC<PageHeadingProps> = ({
  className,
  yellowDividerSmall,
  title,
  subtitle,
  isPageHeading = true,
  body,
  children,
}) => {
  const { ready } = useTranslation();
  const getPageHeading = () => {
    if (!ready) {
      return (
        <div className="skeleton-heading-large">
          <Skeleton
            style={{
              height: "6vh",
            }}
          />
        </div>
      );
    }
    if (isPageHeading) {
      return <h1>{title}</h1>;
    }
    return <h2>{title}</h2>;
  };

  const getSubtitle = () => {
    if (ready && subtitle) {
      return <p className="p4">{subtitle}</p>;
    }
  };

  const getBody = () => {
    if (!ready) {
      return (
        <>
          <div className="skeleton-text-row-1">
            <Skeleton />
          </div>
          <div className="skeleton-text-row-3">
            <Skeleton />
          </div>
          <div className="skeleton-text-row-2">
            <Skeleton />
          </div>
          <div className="skeleton-text-row-1">
            <Skeleton />
          </div>
        </>
      );
    }
    return body;
  };

  return (
    <div
      className={`page-heading ${className ? className : ""}`}
    >
      <div className="container">
        <div className="page-heading__info-wrapper d-flex h-100 flex-column">
          <div className="col-12 col-lg-6 px-0">
            {getPageHeading()}
            <YellowDivider heading={yellowDividerSmall ? "h2" : "h1"} />
            <div className="mx-xl-5 mt-3">
              {getSubtitle()}
              <div className="mx-2 p3">{getBody()}</div>
              <div className="mt-3 d-block d-md-flex">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeadingWithImage;
